import React from 'react';
import './JobPost.css';
import { Link } from 'react-router-dom';
import { sendEmail } from './contact';

const JobPost = () => {
  return (
    <div className="job-background">
      <header className="app-header">
        <div className="header-content">
          <Link to="/">
            <img src={`${process.env.PUBLIC_URL}/assets/retailx.png`} alt="Retail X Logo" className="header-logo" />
          </Link>
          <button className="contact-button" onClick={sendEmail}>Contact Us</button>
        </div>
      </header>

      <div className="job-card">
        <span className="job-tag">Full-time</span>
        <h1>Field Sales Representative</h1>
        <p className="job-location">Stockholm (Office + Field Work) &bull; Retail Industry</p>

        <section className="job-section">
          <h2>About Us</h2>
          <p>We are a growing tech company developing digital tools for bakeries and food businesses. Our platform helps stores take control of their daily operations – from task management and compliance to training and reporting. We're now expanding with new features for catering, customer loyalty, and sales.</p>
          <p>Today, our tools are used by bakery stores across Sweden and we're in an exciting growth phase. We're looking for a driven salesperson who wants to help build something big.</p>
        </section>

        <section className="job-section">
          <h2>About the Role</h2>
          <p>As a Field Sales Representative, you'll work with a mix of phone calls, digital meetings, and on-site customer visits. You'll contact bakeries, pastry shops, and food chains to show how our digital tools can simplify their daily operations – sometimes via a quick phone call, sometimes through a Teams demo, and sometimes by stepping into the store and speaking directly with the owner.</p>
          <p>A typical week might include phone prospecting in the morning, digital demos in the afternoon, and customer visits in the field a day or two per week. You'll drive deals from first contact to close and build relationships both remotely and face-to-face.</p>
          <p>This role is perfect for someone who is flexible, enjoys variety, and thrives switching between phone, screen, and in-person meetings.</p>
        </section>

        <section className="job-section">
          <h2>Responsibilities</h2>
          <ul>
            <li>Prospecting and initial contact via phone, email, and LinkedIn</li>
            <li>Conduct product demos – digitally (Teams/Google Meet) and on-site</li>
            <li>Book and conduct customer meetings at bakeries and food stores</li>
            <li>Quote writing and negotiation</li>
            <li>Follow-up and upselling to existing customers</li>
            <li>Documentation in CRM system</li>
            <li>Represent the company at trade shows and industry events</li>
            <li>Collaborate with product team on customer feedback</li>
          </ul>
        </section>

        <section className="job-section">
          <h2>We're Looking For Someone Who</h2>
          <ul>
            <li>Has experience in B2B sales</li>
            <li>Is comfortable selling both via phone and in physical meetings</li>
            <li>Enjoys variety – one day at the office, the next day out with customers</li>
            <li>Is comfortable with digital tools and CRM systems</li>
            <li>Speaks and writes fluent Swedish</li>
            <li>Has a driver's license</li>
            <li>Is driven, self-motivated, and results-oriented</li>
            <li>Has a genuine interest in helping small business owners succeed</li>
          </ul>

          <h3>Nice to Have</h3>
          <ul>
            <li>Experience from the food industry, bakery, or retail</li>
            <li>Understanding of SaaS business models</li>
            <li>Existing network in the industry</li>
          </ul>
        </section>

        <section className="job-section">
          <h2>This Role Is For You If You Appreciate</h2>
          <ul>
            <li>Variety – phone, digital meetings, and customer visits</li>
            <li>Building relationships your own way</li>
            <li>Selling a product you can stand behind</li>
            <li>Short decision paths and the ability to make an impact</li>
            <li>Great development opportunities in a growing company</li>
            <li>Having fun at work</li>
          </ul>
        </section>

        <section className="job-section">
          <h2>Terms</h2>
          <ul className="terms-list">
            <li><strong>Location:</strong> Stockholm (office + field work)</li>
            <li><strong>Type:</strong> Full-time</li>
            <li><strong>Start:</strong> By agreement</li>
            <li><strong>Compensation:</strong> Base salary + commission</li>
            <li><strong>Other:</strong> Mileage reimbursement for customer visits</li>
          </ul>
        </section>

        <section className="job-section job-apply">
          <h2>Apply</h2>
          <p>Send your CV and a short cover letter. Feel free to tell us how you work best – on the phone, in meetings, or a mix of everything.</p>
          <button className="apply-button" onClick={sendEmail}>Apply Now</button>
        </section>
      </div>
    </div>
  );
}

export default JobPost;
